module.exports = __webpack_public_path__ + "img/logo-marsek.9a46ff9d.png";